export default [{
    path: '/mine/messageCenter',
    name: 'messageCenter',
    meta: {
      index: 14
    },
    component: () => import('@/views/mine/messageCenter.vue')
  }]
  